export default "assets/images/logo-5dc72a30.png";